module.exports = __webpack_public_path__ + "static/img/extend4.edb5639.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new/extend4.png
// module id = L0YY
// module chunks = 0